import AudioPlayer from 'react-h5-audio-player';
import React, { useEffect } from 'react';
import Block from 'lqa-ui/lib/Components/Block';
import 'react-h5-audio-player/lib/styles.css';
import '../../../style/main.scss';
import Icon from 'lqa-ui/lib/Components/Icon';
import { handleVisibilityChange } from '../../../utils/audio';
import { BottomSheet } from '../../../app/common/sharedComponents/BottomSheet';

interface IProps {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  audioUrls: {
    url: string;
    notes?: string;
    id?: number;
  }[];
  setAudio: (i) => void;
}

export const OverlayAudio = (props: IProps) => {
  const { isOpen, setOpen, audioUrls, setAudio } = props;
  const [audioUrl, setAudioUrl] = React.useState(
    audioUrls.slice(0, Env.AUDIO_OVERLAY_MAX_RECORDING_COUNT)[0].url
  );
  const urlFileName = audioUrls.slice(
    0,
    Env.AUDIO_OVERLAY_MAX_RECORDING_COUNT
  )[0].notes;
  const urlFileNameTemp = audioUrl.replace(/[\#\?].*$/, '').split('/');
  const file = urlFileName
    ? urlFileName
    : urlFileNameTemp[urlFileNameTemp.length - 1];
  const [audioFile, setAudioFile] = React.useState(file);
  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={() => {
        setOpen(false);
        setAudio([]);
      }}
    >
      <Block>
        {
          <div className="mb-60">
            <AudioPlayer
              key={audioFile}
              src={audioUrl}
              style={{
                marginTop: '2px',
                height: '250px',
                background: '#4FADA6',
                color: '#ffffff',
              }}
              footer={
                <>
                  <div id="left">
                    <h4>{audioFile}</h4>
                  </div>
                  <hr className="border-top-d1dbec-1" />
                  <div className="d-flex pt-10">
                    {audioUrls
                      .slice(0, Env.AUDIO_OVERLAY_MAX_RECORDING_COUNT)
                      .map((audioData, index) => {
                        const url = audioData.url;
                        const audioNotes = audioData.notes;
                        const fileNameTemp = url
                          .replace(/[\#\?].*$/, '')
                          .split('/');
                        const fileName = audioNotes
                          ? audioNotes
                          : fileNameTemp[fileNameTemp.length - 1];
                        return (
                          // tslint:disable-next-line:jsx-key
                          <div
                            className={`pt-5 pb-5 pl-15 pr-15 mr-5 ${url === audioUrl ? 'background-ABE1DD' : 'background-E1E1E1'} border-radius-10`}
                            onClick={() => {
                              setAudioUrl(url);
                              setAudioFile(fileName);
                            }}
                          >
                            <Icon kind="speakergrey" width={25} height={25} />
                          </div>
                        );
                      })}
                  </div>
                </>
              }
            />
          </div>
        }
      </Block>
    </BottomSheet>
  );
};
